<template>
  <span
      data-toggle="tooltip"
      data-container="body"
      rel="tooltip"
      data-placement="right"
      data-html="true" title=""
      :data-original-title="tooltipText"
      v-if="!isHTML">
     <slot></slot> <font-awesome-icon v-if="showIcon" icon="info-circle" size="sm"/>
  </span>

  <span
      class="pop"
      :class="[showIcon ? null : 'solution-link', showIcon ? null : 'font-italic']"
      data-toggle="popover"
      data-trigger="hover"
      data-placement="right"
      :data-content="tooltipText"
      v-else
  ><slot class="title mt-2"></slot> <span><font-awesome-icon v-if="showIcon" icon="info-circle" size="sm" class="show-icon "/></span></span>

</template>

<script>
import Vue from "vue";
import CONSTANTS from "@/store/constants";

export default {
  name: "HeaderWithTooltip",
  props: {
    tooltipText: {
      type: String
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    isHTML: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    /* eslint-disable no-undef */

    /*
      For any tooltip containing HTML, it needs to persist when user hovers on tooltip so that they can click
      For that reason, we're using bootstrap popovers, which is the else condition below.
      For anything that do not have HTMl, we use bootstrap tooltip, which is the if condition below.
    */

    if(!this.isHTML) {
      Vue.nextTick(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
    } else {
      $(".pop").popover({
        trigger: "manual",
        html: true,
        animation: false
      })
          .on("mouseenter", function() {
            let that = this;
            $(this).popover("show");
            $(".popover").on("mouseleave", function() {
              $(that).popover('hide');
            });
          }).on("mouseleave", function() {
        let that = this;
        setTimeout(function() {
          if (!$(".popover:hover").length) {
            $(that).popover("hide");
          }
        }, CONSTANTS.POPOVER_HIDE_TIMEOUT_IN_MILLIS);
      });
    }

  }

}

</script>
